import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUISwitchControlComponent),
            multi: true
        }],
    selector: "fui-switch-control",
    templateUrl: "./switch-control.component.html",
    standalone: false
})
export class FUISwitchControlComponent extends FUIAbstractControl {
    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext){
        super(changeDetectorRef);
    }
}
